/**
 * Implements Trasnsactions Saga
 * Main idea is to handle intermediate stages for swap transactions and show their statuses
 */
import { END, eventChannel } from '@redux-saga/core';
import { takeLatest, put, take, fork, call } from 'redux-saga/effects';
import {
  actionUpdateTransactionStatus,
  ACTION_ADD_TRANSACTION,
} from '../actions/transactions';
import { Web3Provider } from '@ethersproject/providers';
import {
  IIntermediateTransaction,
  transactionKlassType,
} from '../reducers/transactions';
import { getTransactionStatus } from '../components/Trading/helpers/elrondTrading';
import { toIntermediateTransactionInfo } from './../helpers/intermediateTransactions';

const TIME = 1500;

function* transactionsEventsChannel(
  tx: string,
  klass: transactionKlassType
): any {
  yield put(
    actionUpdateTransactionStatus({
      tx,
      info: toIntermediateTransactionInfo('pending', TIME),
    })
  );

  const injectedEth = (window as any).ethereum;
  const provider = injectedEth
    ? new Web3Provider((window as any).ethereum, 'any')
    : null;

  let counter = 1;
  const chan = eventChannel((emitter) => {
    const iv = setInterval(async () => {
      if (klass === 'EVM' && provider) {
        try {
          const transaction = await provider.getTransactionReceipt.call(
            provider,
            tx
          );
          if (transaction) {
            emitter({
              status: transaction.status ? 'success' : 'failed',
              time: 0,
            });
            emitter(END);
            clearInterval(iv);
          } else {
            emitter({
              status: 'pending',
              time: counter * TIME,
            });
          }
        } catch (e) {
          console.log(e);

          emitter({
            status: 'failed',
            time: 0,
          });
          emitter(END);
          clearInterval(iv);
        }
      } else if (klass === 'Elrond') {
        try {
          const transaction = await getTransactionStatus(tx);
          const status = transaction.data.status;
          if (status === 'success' || status === 'executed') {
            emitter({ status: 'success', time: 0 });
            emitter(END);
            clearInterval(iv);
          } else if (
            status === 'invalid' ||
            status === 'fail' ||
            status === 'not-executed'
          ) {
            emitter({ status: 'failed', time: 0 });
            emitter(END);
            clearInterval(iv);
          } else {
            emitter({ status: 'pending', time: counter * TIME });
            counter++;
          }
        } catch (e) {
          console.log(e);

          emitter({ status: 'failed', time: 0 });
          emitter(END);
          clearInterval(iv);
        }
      }
    }, TIME);

    return () => {
      clearInterval(iv);
    };
  });

  try {
    while (true) {
      const { status, time } = yield take(chan);
      yield put(
        actionUpdateTransactionStatus({
          tx,
          info: toIntermediateTransactionInfo(status, time),
        })
      );
    }
  } finally {
    console.log('transactionsEventsChannel terminated ', tx);
  }
}

function* onAddTransaction(action: any): any {
  const { tx, klass } = action.payload as IIntermediateTransaction;

  yield fork(transactionsEventsChannel, tx, klass);
}

export default function* tradesSaga() {
  yield takeLatest(ACTION_ADD_TRANSACTION, onAddTransaction);
}
